module.exports = __webpack_public_path__ + "img/film-slash.6b34d80c.svg";